import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { IdentityFilterResponse, IdentityResponse } from '../types';

@Injectable({
  providedIn: 'root',
})
export class IdentitiesService {
  private httpClient = inject(HttpClient);

  apiHost = `${environment.apiBaseUrl}`;

  getIdentities(
    branchId: number,
    sort: string,
    order: string,
    page: number,
    pageSize = 50,
    extraParams: HttpParams,
  ): Observable<IdentityResponse> {
    const finalParams = extraParams
      .set('page', page + 1)
      .set('page_size', pageSize)
      .set('order', sort)
      .set('order_direction', order);

    return this.httpClient.get<IdentityResponse>(`${this.apiHost}/Branches/${branchId}/Identities`, { params: finalParams });
  }

  getIdentitiesFilterParams(): Observable<IdentityFilterResponse> {
    const requestUrl = `${this.apiHost}/Identities/FilterParameters`;
    return this.httpClient.get<IdentityFilterResponse>(requestUrl);
  }
}
